import {assert} from '@wix/music-shared/dist/src/utils/assert';
import {WixSdk} from '@wix/js-sdk-wrapper';
import {BI_SCHEMA} from '../biLogger/biEvents';
import {setHref} from '../env/location/location';
import {getSiteInfo} from '../env/siteInfo/siteInfo';
import {isStandalone} from '../env/viewMode/viewMode';

function returnToSite() {
  getSiteInfo().then(({url}) => {
    if (url) {
      setHref(url);
    }
  });
}

export const closePage = (biLogger, buttonName) => {
  assert(biLogger, 'biLogger should be provided');
  assert(buttonName, 'buttonName should be provided');

  biLogger
    .log(BI_SCHEMA.player.downloadPage.close.click, {buttonName})
    .catch((err) => {
      // TODO add reporter
      console.error('Cannot send bi event', err);
    })
    .then(() => {
      if (isStandalone()) {
        returnToSite();
      } else {
        WixSdk.closeWindow();
      }
    });
};
